import React, { useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRouter } from 'next/router';
import { faChevronLeft } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { StickyHeader } from '@components/basics/Table/StickyHeader';
import { IconButton } from '@components/main-components/icon-buttons/IconButton';

export function TwoColumnPageHeader({
  showBackButton = false,
  rightContent,
  backFallbackUrl,
  leftContent,
}: {
  showBackButton?: boolean;
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  backFallbackUrl: string;
}) {
  const { back, push } = useRouter();
  const handleBackClicked = useCallback(() => {
    const prevPage = window.location.href;

    back();

    setTimeout(function () {
      if (window.location.href == prevPage) {
        push(backFallbackUrl);
      }
    }, 500);
  }, [backFallbackUrl, back, push]);

  const leftContentTitle = typeof leftContent === 'string';

  return (
    <StickyHeader
      className=""
      stickyContainerClassName="h-sticky-header-height flex flex-col justify-center md:hidden "
    >
      <div className="flex w-full items-center justify-between">
        <div className="flex items-center justify-start gap-1 lg:gap-5">
          {showBackButton && (
            <>
              <IconButton
                className="-ml-1.5"
                variant="tertiary"
                icon={<FontAwesomeIcon icon={faChevronLeft} fontSize={27} />}
                onClick={handleBackClicked}
              />
            </>
          )}

          {!!leftContentTitle && (
            <h1 className="line-clamp-1 font-title text-title-l font-medium">{leftContent}</h1>
          )}
          {!leftContentTitle && leftContent}
        </div>
        {rightContent}
      </div>
    </StickyHeader>
  );
}
